import React from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';
import ProductDescription from '../product-description/product-description';

import { getProductFitmentPosition } from '../../shared/utils/product/product';

import { ProductData } from '../../shared/types/graphql-types';

import styles from './product-set-description.scss';

interface ProductSetDescriptionProps {
  className?: string;
  product: ProductData;
}

function ProductSetDescription(props: ProductSetDescriptionProps) {
  const { className = '', product } = props;
  const { code, size } = product;
  const productFitmentPosition = getProductFitmentPosition(product);

  return (
    <div className={`product-set-description ${className}`}>
      <Typography
        className={cn(styles['label'], 'product-set-description__label')}
        tag="strong"
        weight="black"
      >
        {productFitmentPosition}
      </Typography>
      <ProductDescription code={code} size={size ? `${size}"` : undefined} />
    </div>
  );
}

export default ProductSetDescription;
